import React from 'react';
import { Stepper, Step, StepLabel, TextField } from '@mui/material';
import {Boton} from '../comun/Index'
import axios from 'axios'
import Caratula from './Caratula';
import Detalles from './Detalles';
import Personas from './Personas';
import Pase from './Pase';

const etapas = [
  {id:0, nombre:"Carátula"},
  {id:1, nombre:"Detalles"},
  {id:2, nombre:"Personas"},
  {id:3, nombre:"Pase"},
  {id:4, nombre:"Subir"}
]

const getCategorias = function(params = null){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/categorias/todos/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.categorias)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}


const getJuzgados = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/emisores/todos/juzgados/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.juzgados)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

const getDefensorias = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/emisores/todos/defensorias'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.defensorias)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}
const getAreas = function(){
  return new Promise(function(resolve, reject) {
    const url = localStorage.getItem('apiUrl') + '/areas/todos/'
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.get(url, config)
    .then((res) => {
      if (res.data.status === "ok"){
        resolve(res.data.areas)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}
const setOficio = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/mesa/';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.oficio_id)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

const setPersonas = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/oficios/todos/personas';
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve()
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  })
}

const getURLPase = function(estado_id){
  let recurso = ''
  switch (estado_id) {
    case 1:
      recurso = '/agente/observado';
      break;
    case 2:
      recurso = '/todos/derivado';
      break;
    case 3:
      recurso = '/agente/parcial';
      break;
    case 4:
      recurso = '/agente/finalizado';
      break;
    default:
      break;
  }
  return(recurso);
}

const setPase = function(datos){
  return new Promise((resolve, reject) => {
    const url = localStorage.getItem('apiUrl') + '/pases' + getURLPase(datos.estado_id);
    const config = {headers:{authorization:sessionStorage.getItem('token')}};
    axios.post(url, datos, config)
    .then((res) => resolve(res.data))
    .catch((error) => reject(error));
  })
}

const getLocalidades = function(){
  return new Promise(function(resolve, reject) {
    axios.get(localStorage.getItem('apiUrl') + '/localidades/listar/')
    .then((res) =>{
      if (res.data.status === "ok"){
        resolve(res.data.localidades)
      } else {
        reject(res.data.error)
      }
    })
    .catch((error) => reject(error))
  });
}

export default class Mesa extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      etapaActual:0,
      categorias:[],
      juzgados:[],
      defensorias:[],
      localidades:[],
      datosCaratula:{
        caratula:"", 
        fecha:"", 
        numero:"", 
        numero_exp:"", 
        anio_exp:"",
        categoriaSelec:null
      },
      datosDetalles:{
        juzgadoSelec:null,
        defensoriaSelec:null,
        plazo_horas:"",
        habil:true,
        tipo:'juzgado',
        observaciones:""
      },
      datosPersonas:{
        oficio_id:null,
        personasSelec:[]
      },
      datosPase:{
        oficio_id:null,
        areaSelec:null,
        estadoSelec:null,
        estado_id:2,
        observaciones:""
      }
    }
  }
  componentDidMount(){
    getLocalidades()
    .then((localidades) => {
      getCategorias()
      .then((categorias) => {
        getJuzgados()
        .then((juzgados) => {
          getDefensorias()
          .then((defensorias) => {
            getAreas()
            .then((areas) => {
              this.setState({categorias, juzgados, defensorias, areas, localidades})
            })
          })
        })
      })
    })
    .catch((error) => {
      alert("Ocurrió un error");
      console.log(error);
    })
  }

  siguienteEtapa(actual){
    if (actual === 1) {
      this.guardarOficio(this.state.datosCaratula,this.state.datosDetalles);
      
    } else if (actual === 2) {
      this.guardarPersonas(this.state.datosPersonas);
    } else if (actual === 3) {
      this.realizarPase(this.state.datosPase);
    } else if (actual === 4) {
      this.guardarArchivos({});
    }
    if (actual === 4) this.props.finalizar();
    this.setState({etapaActual:actual+1})
  }

  anteriorEtapa(actual){
    this.setState({etapaActual:actual-1})
  }
  omitirEtapa(actual){
    if (actual === 4) this.props.finalizar();
    this.setState({etapaActual:actual+1})
  }
  editar(formulario, campo, valor){
    let datosFormulario = JSON.parse(JSON.stringify(this.state[formulario]));
    datosFormulario[campo] = valor;
    this.setState({[formulario]:datosFormulario});
  }
  guardarOficio(datosCaratula, datosDetalles){
    datosCaratula.categoria_id = datosCaratula.categoriaSelec?.id;
    delete datosCaratula.categoriaSelec;
    if (datosDetalles.tipo === 'juzgado') {
      datosDetalles.juzgado_id = datosDetalles.juzgadoSelec.id;
    } else if (datosDetalles.defensoriaSelec !== null) {
      datosDetalles.defensoria_id = datosDetalles.defensoriaSelec.id;
    }
    if (datosDetalles.plazo_horas === '') datosDetalles.plazo_horas = null;
    if (datosCaratula.numero === '') datosCaratula.numero = null;
    delete datosDetalles.defensoriaSelec;
    delete datosDetalles.juzgadoSelec;
    let datos = {...datosCaratula, ...datosDetalles};
    console.log(datos)
    setOficio(datos)
    .then((oficio_id) => {
      this.setState({
        oficio_id,
        datosPersonas:{
          oficio_id,
          personasSelec:[]
        }
      })
      alert("Oficio guardado");
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    })
  }
  guardarPersonas(datos){
    datos.personas = datos.personasSelec.map((persona) => persona.id)
    delete datos.personasSelec;
    setPersonas(datos)
    .then(() => {
      alert("Personas guardado");
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    })
  }
  realizarPase(datosPase){
    let datos = {
      area_id: datosPase.areaSelec.id,
      oficio_id: datosPase.oficio_id,
      estado_id:datosPase.estado_id
    }
    if (datosPase.estadoSelec !== null) datos.estado_id = datosPase.estadoSelec.id;
    setPase(datos)
    .then(() => {
      alert("Pase guardado");
    })
    .catch((error) => {
      console.log(error);
      alert("Ocurrió un error")
    })
  }


  guardarArchivos(datos){

  }

  render(){
    const {
      etapaActual, categorias, juzgados, 
      defensorias, datosCaratula, datosDetalles,
      datosPersonas, localidades,
      areas, datosPase
    } = this.state;
    return(
      <div className="TramitesTodo">
        <h3>Nuevo</h3>
        <div style={{width:'100%'}}>
          <Stepper activeStep={etapaActual} alternativeLabel>
            {etapas.map((etapa, index) => {
              return (
                <Step key={etapa.id}>
                  <StepLabel>{etapa.nombre}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </div>
        {etapaActual === 0 && 
          <Caratula
            categorias={categorias}
            datos={datosCaratula}
            editar={(campo, valor) => this.editar('datosCaratula', campo, valor)}
          />
        }
        {etapaActual === 1 && 
          <Detalles
            juzgados={juzgados}
            defensorias={defensorias}
            datos={datosDetalles}
            editar={(campo, valor) => this.editar('datosDetalles', campo, valor)}
          />
        }
        {etapaActual === 2 && 
          <Personas
            datos={datosPersonas}
            localidades={localidades}
            editar={(campo, valor) => this.editar('datosPersonas', campo, valor)}
          />
        }
        {etapaActual === 3 && 
          <Pase
            nuevo={true}
            areas={areas}
            datos={datosPase}
            editar={(campo, valor) => this.editar('datosPase', campo, valor)}
          />
        }
        {etapaActual === 4 &&
          <span style={{margin:20}}>Trabajando...</span> 
        }
        <div style={{width:'100%', display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
          {etapaActual > 0 && etapaActual < 2 &&
            <Boton
              backgroundColor="#00A6E5"
              titulo="Anterior"
              size={22}
              onClick={() => this.anteriorEtapa(etapaActual)}
            />
          }
          {etapaActual > 1 &&
            <Boton
              backgroundColor="orange"
              titulo="Omitir"
              size={22}
              onClick={() => this.omitirEtapa(etapaActual)}
            />
          }
          <Boton
            disabled={false}
            backgroundColor="#00DF68"
            titulo={etapaActual < 4 ? "Siguiente" : "Finalizar"}
            size={22}
            onClick={() => this.siguienteEtapa(etapaActual)}
          />
        </div>
      </div>
    )
  }
}